import React from "react";
import {
  Grid,
  Box
} from "@mui/material";
import {
  AddToDriveOutlined,
  DoorBackOutlined,
StorageOutlined,
WebAssetOutlined
} from "@mui/icons-material";
import Colors from "../../../../constants/Colors";
import Paper from "@mui/material/Paper";
import {CARD_HEADER_STYLE} from "../../../../constants/Styles";
import {ContainedButton} from "../../../common/StyledButtons";
import {withRouter} from "react-router";
import {getSiteById} from "../../../../selectors/SiteSelectors";
import {observer} from "mobx-react-lite";

const SiteToolsCard = ({ match }) => {
  const siteId = match.params.site_id
  const site = getSiteById(siteId)

  const prepareTools = () => {
    const tools = []
    if (site.site_external_connections.box) {
      tools.push({
        name: "Share a File",
        icon: <AddToDriveOutlined sx={{ color: Colors.primaryColor, fontSize: '64px' }} />,
        description: 'Securely view and share files with BCK, powered by Google Drive.',
        link: site.site_external_connections.box.box_url})
    }
    if (site.site_external_connections.wordpress) {
      tools.push({
        name: "Wordpress Dashboard",
        icon: <WebAssetOutlined sx={{ color: Colors.primaryColor, fontSize: '64px' }} />,
        description: 'Access to your website media and content.',
        link: site.site_external_connections.wordpress.wordpress_login_url})
    }
    tools.push({
      name: "Advanced Panel",
      icon: <DoorBackOutlined sx={{ color: Colors.primaryColor, fontSize: '64px' }} />,
      description: 'Backend access for your site & services.',
      link: 'https://d-90679ff33b.awsapps.com/start/'
    })
    
    return tools
  }

  const renderToolCards = () =>
    prepareTools().map((tool) => (
      <Grid item xs={12} key={tool.name}>
        <Paper
          variant="outlined"
          onClick={() => window.open(tool.link, '_blank')}
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            transition: 'all 0.2s ease',
            cursor: 'pointer',
            boxSizing: 'border-box',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                transform: 'scale(1.02)',
              },
          }}
        >
          {/* Left: Icon + Text */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
            <Box>{tool.icon}</Box>
            <Box>
              <div style={CARD_HEADER_STYLE}>{tool.name}</div>
              <p style={{ margin: 0 }}>{tool.description}</p>
            </Box>
          </Box>

          {/* Right: Button */}
          <Box sx={{ marginLeft: '10px' }}>
            <ContainedButton
              
              sx={{ padding: '8px 16px' }}
            >
              Access
            </ContainedButton>
          </Box>
          
        </Paper>
    </Grid>
  ));

  return (
    <Grid container item xs={12} spacing={1}>
      {renderToolCards()}
    </Grid>
  )
}

export default observer(withRouter(SiteToolsCard));
